MOVE.AutoComplete = (function(MOVE) {
  "use strict";

  // Disables the native HTML form handling and allows the custom form handling
  // to take over instead.
  var disableHtmlForm = function($selector) {
    $selector.closest('form.inline-form').contents().unwrap();
    $selector.parent().find('button[type=submit]').attr('type', 'button');
  };

  var init = function ($selector, latLongInfo, isSRP, options) {
    disableHtmlForm($selector);
    var combinedOptions = $.extend({isSRP:isSRP, latLongInfo:latLongInfo}, options);
    $selector.autocomplete(combinedOptions);
  };

  MOVE.AutoComplete =
  {
    init: init
  };
  return MOVE.AutoComplete;

})(MOVE || {});



// WEBPACK FOOTER //
// ./shared_critical/auto_complete.js